import { Box, Button, ButtonGroup, Collapse, Stack } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { Fragment, useEffect, useRef } from "react";
import Icons from "../../../assets/js/Icons";

function Navmenu({ menu, activeIndex, setActiveIndex, index }) {
  const menuRef = useRef(null);
  const { pathname } = useLocation();
  const isActive = activeIndex === index;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!menuRef?.current?.contains(event.target)) {
        setActiveIndex(null);
      }
    };

    if (isActive) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isActive, setActiveIndex]);

  return (
    <Box sx={{ position: "relative" }} ref={menuRef}>
      {menu?.menus ? (
        <Fragment>
          {menu?.name === "services" ? (
            <ButtonGroup
              sx={{
                mx: { xs: 0.5, md: 1 },
                px: { xs: 0, xxl: 1 },
                ":hover:after": { height: "3px" },
                ":after": {
                  left: "0",
                  right: "0",
                  bottom: "0",
                  content: "''",
                  borderRadius: "1px",
                  position: "absolute",
                  bgcolor: "primary.main",
                  height: pathname === "/services" ? "3px" : "0px",
                },
              }}
            >
              <Button
                sx={{
                  py: 3,
                  px: "0",
                  border: "none",
                  letterSpacing: "0",
                  position: "relative",
                  textTransform: "capitalize",
                  fontSize: { xs: 15, md: 14, xxl: 16 },
                  ".MuiButton-icon": { m: "0" },
                  ":hover": { color: "primary.main" },
                  color:
                    pathname === "/services" ? "primary.main" : "dark.main",
                }}
                disableRipple
                LinkComponent={Link}
                to="/services"
              >
                Services
              </Button>
              <Button
                sx={{
                  px: "0",
                  border: "none",
                  fontSize: "20px",
                  color: "dark.main",
                  minWidth: "auto !important",
                  ":hover": { color: "primary.main" },
                }}
                size="small"
                disableRipple
                onClick={() => setActiveIndex(isActive ? null : index)}
              >
                <Icons.ArrowDown1 />
              </Button>
            </ButtonGroup>
          ) : (
            <Button
              sx={{
                mx: { xs: 0.5, md: 1 },
                py: 3,
                borderRadius: "0",
                letterSpacing: "0",
                position: "relative",
                px: { xs: 0, xxl: 1 },
                textTransform: "capitalize",
                fontSize: { xs: 15, md: 14, xxl: 16 },
                ".MuiButton-icon": { m: "0" },
                ":hover:after": { height: "3px" },
                ":hover": { color: "primary.main" },
                ":after": {
                  left: "0",
                  right: "0",
                  bottom: "0",
                  content: "''",
                  borderRadius: "1px",
                  position: "absolute",
                  bgcolor: "primary.main",
                  height: !true ? "3px" : "0px",
                },
                color: !true ? "primary.main" : "dark.main",
              }}
              disableRipple
              endIcon={<Icons.ArrowDown1 />}
              onClick={() => setActiveIndex(isActive ? null : index)}
            >
              {menu?.name}
            </Button>
          )}
        </Fragment>
      ) : (
        <Button
          disableRipple
          to={menu?.path}
          LinkComponent={Link}
          sx={{
            mx: { xs: 0.5, md: 1 },
            py: 3,
            minWidth: "auto",
            letterSpacing: "0",
            borderRadius: "0",
            position: "relative",
            px: { xs: 0, xxl: 1 },
            textTransform: "capitalize",
            fontSize: { xs: 15, md: 14, xxl: 15},
            ":hover": { color: "primary.main" },
            ":hover:after": { height: "3px" },
            ":after": {
              left: "0",
              right: "0",
              bottom: "0",
              content: "''",
              borderRadius: "1px",
              position: "absolute",
              bgcolor: "primary.main",
              height:
                menu?.path === pathname
                  ? "3px"
                  : menu?.name === "home" && pathname === "/"
                    ? "3px"
                    : "0px",
            },
            color:
              menu?.path === pathname
                ? "primary.main"
                : menu?.name === "home" && pathname === "/"
                  ? "primary.main"
                  : "dark.main",
          }}
        >
          {menu?.name}
        </Button>
      )}
      {menu?.menus && (
        <Collapse
          in={isActive}
          timeout={300}
          unmountOnExit
          sx={{
            left: "0",
            top: "100%",
            zIndex: "10",
            minWidth: "100%",
            bgcolor: "white",
            position: "absolute",
            borderRadius: "6px",
            border: "1px solid #0000002d",
          }}
        >
          <Stack spacing={0.5}>
            {menu?.menus?.map((item, i) => (
              <Button
                sx={{
                  py: 0.5,
                  borderRadius: "0",
                  justifyContent: "start",
                  ":hover": { bgcolor: "#2f425017" },
                }}
                key={i}
                color="dark"
                disableRipple
                to={item?.path}
                LinkComponent={Link}
                onClick={() => {
                  setActiveIndex(null);
                }}
              >
                {item?.name}
              </Button>
            ))}
          </Stack>
        </Collapse>
      )}
    </Box>
  );
}

export default Navmenu;
